import React, { useEffect,useState } from "react";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import "./Event.css";
import moment from "moment";

const EventListView = ({
    events,
    identifyGroups,
    history
}) => {

    const [filteredEvents, setFilteredEvents] = useState([]);

    useEffect(() => {

        if (events && events.length > 0) {
            let upcoming = []
            events.map(event => {
                if (new Date(event.finishDate) > new Date()) {
                    upcoming.push(event);
                }
            })
            setFilteredEvents(upcoming);
        }

    }, [events])

    return (
        <React.Fragment>
            {(filteredEvents.length === 0) &&
                <div className="empty-message">
                    <span className="far fa-calendar-alt empty-icon"></span>
                    <div className="empty-text">You don't have any upcoming events</div>
                </div>
            }
            {filteredEvents.map(e => {
                    return (
                        <div key={e.id} className="col-12 justify-content-center">
                            <div className="card event-list-card mb-3" >
                                <Link to={`/events/${e.id}`}>
                                    <div className="row no-gutters">
                                        <div className="event-list-card-imgbox col-md-4">
                                            <img className="card-img" src={`${apiConfig.API_URL}routes/routepreview/${e.routes[0].id}.png?size=lrg`} alt="Card image" />
                                            {identifyGroups &&
                                                ( e.groupHasAvatar ?
                                                    <UserAvatar className="event-group-avatar sml" size="50" name={`${e.groupName}`} src={`${apiConfig.API_URL}groups/avatar/${e.groupId}.png`} />
                                                    :
                                                    <div className="event-group-avatar default sml"><span className="fas fa-users" /></div>
                                                )
                                            }
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-10 event-header">
                                                        <h5 className="card-title">{e.name}</h5>
                                                        <ul className="event-details">
                                                            {identifyGroups &&
                                                                <li><small className="text-muted"><span className={'fas fa-users'}></span>Group: {e.groupName}</small></li>
                                                            }
                                                            <li><small className="text-muted"><span className={'fas fa-clock'}></span>{moment(e.startDate).format("dddd DD MMMM hh:mm A")}</small></li>
                                                            <li><small className="text-muted"><span className={'fas fa-route'}></span>Route: {e.routes[0].name}</small></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-2" >
                                                        <div className="calendar-date">
                                                            <div className="calendar-date-day">
                                                                {moment(e.startDate).format("dddd")}
                                                            </div>
                                                            <div className="calendar-date-month">
                                                                {moment(e.startDate).format("MMM")}
                                                            </div>
                                                            <div className="calendar-date-date">
                                                                {moment(e.startDate).format("DD")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-text">{e.description}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    )
                   
                })}
        </React.Fragment>

    );
}

EventListView.propTypes = {
    events: PropTypes.array.isRequired,
    identifyGroups: PropTypes.bool
}

export default EventListView;




// WEBPACK FOOTER //
// ./src/components/events/EventListView.js